import { useEffect } from "react";

import { FiltersContext } from "components/Filters";
import { URL_FILTER_TAB_KEY } from "constants/url_query_keys";
import usePrevious from "hooks/usePrevious";
import useTypedContext from "hooks/useTypedContext";
import useURLParams from "hooks/useURLParams";

import useStacksTableSelectionStore from "../Table/useStacksTableSelectionStore";

type StackFiltersLayoutSyncWithPredefinedTabsProps = {
  syncCallback?: () => void;
};

const StackFiltersLayoutSyncWithPredefinedTabs = ({
  syncCallback,
}: StackFiltersLayoutSyncWithPredefinedTabsProps) => {
  const urlParams = useURLParams();
  const tab = urlParams.get(URL_FILTER_TAB_KEY);
  const prevTab = usePrevious(tab);

  const clearSelected = useStacksTableSelectionStore((state) => state.clearSelected);

  const { forceReMountSidebar, setActiveFiltersFromInitialParams } =
    useTypedContext(FiltersContext);

  useEffect(() => {
    if (prevTab !== tab) {
      forceReMountSidebar();
      setActiveFiltersFromInitialParams();
      clearSelected();
      syncCallback?.();
    }
  }, [
    prevTab,
    tab,
    forceReMountSidebar,
    setActiveFiltersFromInitialParams,
    clearSelected,
    syncCallback,
  ]);

  return null;
};

export default StackFiltersLayoutSyncWithPredefinedTabs;
